import { FilledAddress, TKV2_PUBLIC_RECORDS_API } from '@aloft/toolkit-shared';
import { UseQueryResult } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2PublicRecordsAPIVariables,
  useGetTkv2PublicRecordsAPI,
} from '../../hooks/api/toolkitComponents.ts';
import { PublicRecords } from '../types.ts';
import { ListingResult } from './listings/types.ts';

const _schema = TKV2_PUBLIC_RECORDS_API.GET;

export const usePublicRecordsFromListings = (
  pathParams: z.infer<typeof _schema.REQUEST.PATH_PARAMS>,
  listings: UseQueryResult<ListingResult>[],
  addressesByID: Record<string, FilledAddress>,
): {
  isLoading: boolean;
  data?: PublicRecords;
} => {
  // Don't fetch public records yet if we are still loading the listing data (in case we need to use it for the address))
  const disablePublicRecordsFetch =
    listings.filter((result) => result.status === 'pending').length > 0;

  const queryParams = Object.fromEntries(
    Object.keys(addressesByID).map((addressID) => [addressID, addressesByID[addressID]]),
  );

  const variables: GetTkv2PublicRecordsAPIVariables = {
    pathParams,
    queryParams: {
      addresses: encodeURIComponent(JSON.stringify(queryParams)),
    },
  };

  return useGetTkv2PublicRecordsAPI(variables, {
    gcTime: Infinity,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !disablePublicRecordsFetch,
  });
};
